import { View, Text, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  footer: {
    position: "absolute",
    bottom: 30,
    left: 30,
    right: 30,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: "#e5e7eb",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  text: {
    fontSize: 8,
    color: "#9ca3af"
  },
  pageNumber: {
    fontSize: 8,
    color: "#9ca3af"
  }
});

interface FooterProperties {
  dataGeracao: string;
}

/**
 *
 * @param root0
 * @param root0.dataGeracao
 */
export function Footer({ dataGeracao }: FooterProperties) {
  return (
    <View style={styles.footer} fixed>
      <Text style={styles.text}>Gerado em: {dataGeracao}</Text>
      <Text
        style={styles.pageNumber}
        render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`}
      />
    </View>
  );
}
